import { useLongfansMock } from "../global/GlobalMock";
import { post } from "../utils/Backend";
import { mockCorporatePortalTestModeConfig } from "./CorporatePortalMock";

export type CorporatePortalTestModeConfig = {
  enabled: boolean;
};

const DEFAULT_CONFIG: CorporatePortalTestModeConfig = {
  enabled: false,
};

const mockPortal = false;

export const CorporatePortalApi = {
  async getTestModeConfig(): Promise<CorporatePortalTestModeConfig> {
    if (useLongfansMock && mockPortal) {
      return { ...mockCorporatePortalTestModeConfig };
    }
    const res = await post<Record<string, never>, CorporatePortalTestModeConfig>(
      "/lark/app/home/getLongfansPortalTestModeConfig",
      {},
      { silent: true }
    );
    if (typeof res === "string" || res == null) {
      return { ...DEFAULT_CONFIG };
    }
    return { enabled: !!res.enabled };
  },
};
